import { useCognitoMutation } from "@workspace/casino_core/mutations/CognitoMutation.client";
import filterAuthResponse from "../helpers/utils";

const useHandleCognitoAuthenticate = () => {
  const [completeCognitoRegistration, { loading }] = useCognitoMutation();
  const handleCognitoAuthenticate = async (
    variables: AuthVariables,
    accessToken: string,
  ) => {
    const response = await completeCognitoRegistration({
      ...variables,
      accessToken: accessToken,
    });
    return filterAuthResponse(
      response?.data?.userManagementCognitoAuthenticate,
    );
  };
  return {
    handleCognitoAuthenticate,
    loading,
  };
};

export default useHandleCognitoAuthenticate;
